export default class BiPaiTableChatData {
    static ChatTextList: { [key: string]: string; } = 
    {  
        "1" : "不要吵啦，专心玩游戏吧！",  
        "2" : "不要和我抢！地主是我的！",
        "3" : "哼！和我斗你还嫩了点！",
        "4" : "快点吧！我等得花儿都谢啦！",
        "5" : "你的牌打得也太好了。",
        "6" : "牌运来的时候真是挡也挡不住呀。",
        "7" : "辛辛苦苦几十年，一把回到解放前。",
    }
}
